import { ActionContext } from 'vuex'
import apiAdminAdminFleet from '@/api/admin/adminFleet'
import apiMission from '@/api/mission'

import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IAdminFleetState } from './state'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import { AloError } from '@/models/alo/AloError'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { router } from '@/mainjs.js'
import { AloDbFleetConfig } from '@/models/alodb/AloDbFleetConfig'
import {i18n} from '@/locale/vueI18n'
import { IFleetIrisConfigFormation } from '@/models/iris/fleet/IFleetIrisConfigFormation'
import { IFleetIrisConfigCoverage } from '@/models/iris/fleet/IFleetIrisConfigCoverage'
import { AloLogbookChannel } from '@/models/alo/AloLogbookChannel'
import { AloLogbookItem } from '@/models/alo/AloLogbookItem'
import { WobAdminChanged } from '@/models/wob/WobAdminChanged'

export class AdminFleetAction {
   
  public [types.ADMINFLEET_REQUEST](context: ActionContext<IAdminFleetState, IRootState>) {    
    return new Promise((resolve, reject) => {
        context.commit(types.ADMINFLEET_REQUEST)
        apiAdminAdminFleet
          .getAdminFleets()
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const adminFleetArray = resp.data.data as AloBaseArray<AloDbFleet>
              context.commit(types.ADMINFLEET_SUCCESS, adminFleetArray.items)
              resolve(adminFleetArray.items)
            } else {
              context.commit(types.ADMINFLEET_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(resp => {
            context.commit(types.ADMINFLEET_ERROR)
            reject()
          })
      })
  }

  public [types.ADMINFLEET_ENSURE_LIST](context: ActionContext<IAdminFleetState, IRootState>) {
    if(context.state.adminFleetsId.length == 0) {
        return context.dispatch(types.ADMINFLEET_REQUEST)
    }
    else {
        return new Promise((resolve, reject) => {            
            resolve(context.getters.adminFleets)            
        })
    }    
  }

  public [types.ADMINFLEET_SELECT_DETAIL](context: ActionContext<IAdminFleetState, IRootState>, itemId:number) {        
    return new Promise((resolve, reject) => {
      const adminFleet = context.getters.adminFleetsById[itemId] as AloDbFleet      
      if(adminFleet) {        
        if(adminFleet.detailLoaded) {
          context.commit(types.ADMINFLEET_SELECT_DETAIL,adminFleet)
          resolve(adminFleet)
        }
        else{
          context.dispatch(types.ADMINFLEET_SELECT_DETAIL_REQUEST,itemId).then((ens) => {
            context.commit(types.ADMINFLEET_SELECT_DETAIL,ens)
            resolve(ens)
          })
        }
      }    
      else{
        const newAdminFleet = new AloDbFleet()
        context.commit(types.ADMINFLEET_SELECT_DETAIL,newAdminFleet)
        resolve(newAdminFleet)
      }
    })
  }

  public [types.ADMINFLEET_SELECT_DETAIL_REQUEST](context: ActionContext<IAdminFleetState, IRootState>, itemId:number) {
    return new Promise((resolve, reject) => {
        context.commit(types.ADMINFLEET_SELECT_DETAIL_REQUEST, itemId)
        apiAdminAdminFleet
          .getAdminFleet(itemId)
          .then(resp => {                        			
            if (resp.data.resultCode == ApiResultCode.Ok) {
               const adminFleet = resp.data.data as AloDbFleet
               context.dispatch(types.UI_ENSURE_FLEET_STATE, { ids: [adminFleet.FLE_ID], typeUiid: 'detail' }).then(() => {
                context.dispatch(types.UI_ENSURE_MISSION_STATE, { ids: adminFleet.param?.missionIds, typeUiid: 'fleet' }).then(() => {        
                  //lance la creation des models de mission state Ui si necessaire                  
                  context.commit(types.ADMINFLEET_SELECT_DETAIL_SUCCESS, adminFleet)              
                  //context.commit(types.ADMINFLEET_SELECT_DETAIL,adminFleet)
                  context.commit(types.FLEET_UPDATE_DETAIL_SUCCESS,adminFleet)
                  resolve(adminFleet)
                })          
              })                
            } else {
              context.commit(types.ADMINFLEET_SELECT_DETAIL_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            context.commit(types.ADMINFLEET_SELECT_DETAIL_ERROR)
            reject()
          })
      })
  }

  public [types.ADMINFLEET_SAVE_REQUEST](context: ActionContext<IAdminFleetState, IRootState>) {    
    return new Promise((resolve, reject) => { 
        const tryRedirect = !context.state.modifiedAdmAdminFleet.id
        context.commit(types.ADMINFLEET_SAVE_REQUEST,context.state.modifiedAdmAdminFleet.FLE_LIBELLE)
        apiAdminAdminFleet
          .saveAdminFleet(context.state.modifiedAdmAdminFleet)                    
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const adminFleet = resp.data.data as AloDbFleet            
              context.commit(types.ADMINFLEET_SELECT_DETAIL_SUCCESS, adminFleet)
              context.commit(types.ADMINFLEET_SELECT_DETAIL,adminFleet)                    
              context.commit(types.FLEET_UPDATE_DETAIL_SUCCESS,adminFleet)         
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:adminFleet.FLE_LIBELLE}))               
              if(tryRedirect && router.app.$route.name === 'NewAdminFleet') router.push({name:'EditAdminFleet',params:{adminFleetid:adminFleet.id!.toString()}})
              resolve(adminFleet)
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.ADMINFLEET_SAVE_ERROR)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.ADMINFLEET_SAVE_ERROR)
            if(error.response){
              const er = error.response.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
              console.error(er)
              reject(er)
            }   
            else{         
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
              reject()
            }            
          })
      })
  }

  public [types.ADMINFLEET_DELETE_REQUEST](context: ActionContext<IAdminFleetState, IRootState>,fleet:AloDbFleet) {
    return new Promise<void>((resolve, reject) => {      
      const fleetId = fleet?fleet.FLE_ID!:context.state.originalAdmAdminFleet.FLE_ID!
      const fleetLabel = fleet?fleet.FLE_LIBELLE:context.state.originalAdmAdminFleet.FLE_LIBELLE          

      context.commit(types.ADMINFLEET_DELETE_REQUEST, fleetLabel)
      apiAdminAdminFleet
        .deleteAdminFleet(fleetId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            context.commit(types.ADMINFLEET_DELETE_SUCCESS, fleetId)
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.DeleteOk',{item:fleetLabel}))   
            if (router.app.$route.name === 'EditAdminFleet' && context.state.originalAdmAdminFleet.FLE_ID! == fleetId) {
              router.push({ name: 'NewAdminFleet' })
            }
            resolve()
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.ADMINFLEET_DELETE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.ADMINFLEET_DELETE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
            console.error(er)
            reject(er)
          } else {
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
            reject()
          }
        })
    })
  }

  

  public [types.ADMINFLEET_UPDATE_MODIFIED_ADM](context: ActionContext<IAdminFleetState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.ADMINFLEET_UPDATE_MODIFIED_ADM,newProperties)
      resolve(context.state.modifiedAdmAdminFleet)
    })
  }
  
  public [types.ADMINFLEET_CANCEL_MODIFIED_ADM](context: ActionContext<IAdminFleetState, IRootState>) {        
    return new Promise((resolve, reject) => {
      context.commit(types.ADMINFLEET_SELECT_DETAIL,context.state.originalAdmAdminFleet)
      resolve(context.state.modifiedAdmAdminFleet)
    })
  }

  public [types.ADMINFLEET_UPDATE_FILTER_ADM](context: ActionContext<IAdminFleetState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.ADMINFLEET_UPDATE_FILTER_ADM,newProperties)
      resolve(context.state.adminFilter)
    })
  }

  public [types.ADMINFLEET_CONFIG_REQUEST](context: ActionContext<IAdminFleetState, IRootState>, itemId:number) {    
    return new Promise((resolve, reject) => {
        context.commit(types.ADMINFLEET_CONFIG_REQUEST)
        apiAdminAdminFleet
          .getAdminFleetConfigs(itemId)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const adminConfigFleetArray = resp.data.data as AloBaseArray<AloDbFleetConfig>
              context.commit(types.ADMINFLEET_CONFIG_SUCCESS, adminConfigFleetArray.items)
              resolve(adminConfigFleetArray.items)
            } else {
              context.commit(types.ADMINFLEET_CONFIG_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(resp => {
            context.commit(types.ADMINFLEET_CONFIG_ERROR)
            reject()
          })
      })
  }

  public [types.ADMINFLEET_ENSURE_CONFIG_LIST](context: ActionContext<IAdminFleetState, IRootState>, itemId:number) {
    if(context.getters.fleetConfigsByFleet[itemId] && context.state.currentConfig.FLE_ID == itemId ) {
      return new Promise((resolve, reject) => {            
          resolve(context.getters.fleetConfigsByFleet[itemId])            
      })
    }
    else {
      return context.dispatch(types.ADMINFLEET_CONFIG_REQUEST,itemId)        
    }    
  }

  public [types.ADMINFLEET_ENSURE_CONFIG_DETAIL](context: ActionContext<IAdminFleetState, IRootState>, itemId:number) {        
    const configFleet = context.getters.fleetConfigsById[itemId] as AloDbFleetConfig      
    if(configFleet && configFleet.detailLoaded) {              
      return new Promise((resolve, reject) => {
        resolve(configFleet)
      })
    }                
    else{
      return context.dispatch(types.ADMINFLEET_CONFIG_DETAIL_REQUEST,itemId)
    }      
  }

  public [types.ADMINFLEET_CONFIG_DETAIL_REQUEST](context: ActionContext<IAdminFleetState, IRootState>, config:AloDbFleetConfig) {
    return new Promise((resolve, reject) => {
        context.commit(types.ADMINFLEET_CONFIG_DETAIL_REQUEST, config)
        apiAdminAdminFleet
          .getAdminFleetConfig(config.FLE_ID!, config.FLC_ID!)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const configFleet = resp.data.data as AloDbFleetConfig
              context.commit(types.ADMINFLEET_CONFIG_DETAIL_SUCCESS, configFleet)              
              resolve(configFleet)
            } else {
              context.commit(types.ADMINFLEET_CONFIG_DETAIL_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            context.commit(types.ADMINFLEET_CONFIG_DETAIL_ERROR)
            reject()
          })
      })
  }

  public [types.ADMINFLEET_SAVE_CONFIG_REQUEST](context: ActionContext<IAdminFleetState, IRootState>,config:AloDbFleetConfig) {    
    return new Promise((resolve, reject) => {         
        context.commit(types.ADMINFLEET_SAVE_CONFIG_REQUEST,config)
        apiAdminAdminFleet
          .saveAdminFleetConfig(config)                    
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const config = resp.data.data as AloDbFleetConfig            
              context.commit(types.ADMINFLEET_CONFIG_DETAIL_SUCCESS, config)                            
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:'configuration'}))                          
              resolve(config)
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.ADMINFLEET_SAVE_CONFIG_ERROR)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))              
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.ADMINFLEET_SAVE_CONFIG_ERROR)
            if(error.response){
              const er = error.response.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
              console.error(er)
              reject(er)
            }   
            else{         
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
              reject()
            }            
          })
      })
  }

  public [types.ADMINFLEET_SHOW_HISTOCONFIG](context: ActionContext<IAdminFleetState, IRootState>,config:AloDbFleetConfig) {     
    return new Promise((resolve, reject) => {        
      if(config.detailLoaded) {
        context.commit(types.ADMINFLEET_SHOW_HISTOCONFIG,config)
        resolve(config)
      }
      else{
        context.dispatch(types.ADMINFLEET_CONFIG_DETAIL_REQUEST,config).then((ens) => {
          context.commit(types.ADMINFLEET_SHOW_HISTOCONFIG,ens)
          resolve(ens)
        })
      }  
    })
  }

  public [types.ADMINFLEET_HIDE_HISTOCONFIG](context: ActionContext<IAdminFleetState, IRootState>) {     
    return new Promise<void>((resolve, reject) => {     
        context.commit(types.ADMINFLEET_HIDE_HISTOCONFIG)
        resolve()   
    })
  }

  public [types.ADMINFLEET_PUBLISH_IRIS_REQUEST](context: ActionContext<IAdminFleetState, IRootState>, config:IFleetIrisConfigFormation|IFleetIrisConfigCoverage ) {
    return new Promise((resolve, reject) => {
        //context.commit(types.ADMINFLEET_PUBLISH_IRIS_REQUEST, config)
        const fleId = context.state.modifiedAdmAdminFleet.FLE_ID!
        apiAdminAdminFleet
          .publishFleetToIris(fleId, config)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire              
              context.dispatch(types.FLEET_SELECT_DETAIL_REQUEST,fleId).then((ens) => {                
                resolve(ens)
              })                            
            } else {
              //context.commit(types.ADMINFLEET_PUBLISH_IRIS_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            //context.commit(types.ADMINFLEET_PUBLISH_IRIS_ERROR)
            reject()
          })
      })
  }

   public [types.ADMINFLEET_SEND_COMMAND_IRIS_REQUEST](context: ActionContext<IAdminFleetState, IRootState>, command:string ) {
    return new Promise((resolve, reject) => {
        //context.commit(types.ADMINFLEET_PUBLISH_IRIS_REQUEST, config)
        const fleId = context.state.modifiedAdmAdminFleet.FLE_ID!
        const data = {
          fleet_type: context.state.modifiedAdmAdminFleet.config?.fleet_type as string,
          fleet_command: command
        }        
        apiAdminAdminFleet
          .sendCommand(fleId, data)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire              
              context.dispatch(types.FLEET_SELECT_DETAIL_REQUEST,fleId).then((ens) => {                
                resolve(ens)
              })                            
            } else {
              //context.commit(types.ADMINFLEET_SEND_COMMAND_IRIS_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            //context.commit(types.ADMINFLEET_SEND_COMMAND_IRIS_ERROR)
            reject()
          })
      })
  }

   
    

     public [types.ADMINFLEET_EXTERNAL_UPDATE](
        context: ActionContext<IAdminFleetState, IRootState>,wob: WobAdminChanged<AloDbFleet>
      ) {
        return new Promise<void>((resolve, reject) => {                    
          if(wob.actionType == "Deleted") {    
            context.commit(types.ADMINFLEET_EXTERNAL_UPDATE, wob)
          }
          else {
            const newIdx = context.rootState.fleet.detailFleets.findIndex(it => it.fleet.FLE_ID == wob.newAloDbItem.FLE_ID) 
            if(wob.actionType == "Added" || newIdx >=0) {
              context.dispatch(types.ADMINFLEET_SELECT_DETAIL_REQUEST, wob.newAloDbItem.FLE_ID )
            }
          }
          resolve()
        })
      }
    
  

  
}

export default util.classToObject(AdminFleetAction)